// import { ADMIN_ANALYTICS_ACTIONS, ADMIN_AVERAGE_SESSION_GRAPH_ACTIONS, ADMIN_BOUNCE_RATE_GRAPH_ACTIONS, ADMIN_NAVIGATIONPATH_GRAPH_ACTIONS, ADMIN_PAGEVIEW_GRAPH_ACTIONS, ADMIN_UNIQUEVIEW_GRAPH_ACTIONS, ADMIN_ANALYTICS_TABLEDATA_ACTIONS, ADMIN_ANALYTICS_EXITDATA_ACTIONS, ADMIN_ANALYTICS_CTA_GRAPH_ACTIONS } from "../../../actionsType/admin/analytics";
import { ADMIN_ANALYTICS_ACTIONS, ADMIN_AVERAGE_SESSION_GRAPH_ACTIONS, ADMIN_BOUNCE_RATE_GRAPH_ACTIONS, ADMIN_NAVIGATIONPATH_GRAPH_ACTIONS, ADMIN_PAGEVIEW_GRAPH_ACTIONS, ADMIN_UNIQUEVIEW_GRAPH_ACTIONS, ADMIN_ANALYTICS_TABLEDATA_ACTIONS, ADMIN_ANALYTICS_EXITDATA_ACTIONS, ADMIN_CTA_GRAPH_ACTIONS, ADMIN_ANALYTICS_CTA_GRAPH_ACTIONS, ADMIN_DEVICE_BROWSER_CHART_ACTIONS, ADMIN_COUNTRY_USERS_CHART_ACTIONS, ADMIN_ANALYTICS_TABLEDATA_CUSTOM_ACTIONS, ADMIN_ANALYTICS_DATA_TABLE_DATA_ACTIONS, ADMIN_ADSLOG_DATA_TABLE_ACTIONS } from "../../../actionType/admin/analytics";

const intialState = {
    analyticsData: {},
    isAdminAnalyticsLoader: false,
    pageViewGraphData: {},
    isAdminPageViewGraphLoader: false,
    uniqueViewsGrapghData: {},
    isAdminUniqueViewSGraphLoader: false,
    navigationPathGraphData: {},
    isAdminNavigationPathGraphLoader: false,
    averageSessionGraphData: {},
    isAdminAverageSessionGraphLoader: false,
    bounceRateGraphData: {},
    isAdminBounceRateGraphLoader: false,
    analyticsTableData: {},
    isAdminAnalyticsTableLoader: false,
    analyticsCustomTableData: {},
    isAdminAnalyticsCustomTableLoader: false,
    analyticsExitTableData: {},
    isAdminAnalyticsExitTableLoader: false,
    analyticsCTAGraphData: {},
    isAdminAnalyticsCTAGraphLoader: false,
    CTAGraphData: {},
    isAdminCTAGraphLoader: false,
    deviceBrowserChartData: {},
    isAdminDeviceBrowserChartLoader: false,
    isAdminCountryUsersChartLoader: false,
    countryUsersChartData: {},
    analyticsDataTableData: {},
    isAdminAnalyticsDataTableLoader: false,
    adsLogDataTableData: {},
    isAdminAdsLogDataTableLoader: false,
};

export const adminAnalyticsReducer = (
    state = intialState,
    { type, payload }: any
) => {
    switch (type) {

        // ADMIN_ANALYTICS_ACTIONS
        case ADMIN_ANALYTICS_ACTIONS.ADMIN_ANALYTICS_REQUEST:
            return { ...state, isAdminAnalyticsLoader: true };
        case ADMIN_ANALYTICS_ACTIONS.ADMIN_ANALYTICS_RESPONSE:
            return {
                ...state,
                analyticsData: payload,
                isAdminAnalyticsLoader: false,
            };
        case ADMIN_ANALYTICS_ACTIONS.ADMIN_ANALYTICS_ERROR:
            return {
                ...state,
                analyticsData: payload,
                isAdminAnalyticsLoader: false,
            };


        // ADMIN_PAGEVIEW_GRAPH_ACTIONS
        case ADMIN_PAGEVIEW_GRAPH_ACTIONS.ADMIN_PAGEVIEW_GRAPH_REQUEST:
            return { ...state, isAdminPageViewGraphLoader: true };
        case ADMIN_PAGEVIEW_GRAPH_ACTIONS.ADMIN_PAGEVIEW_GRAPH_RESPONSE:
            return {
                ...state,
                pageViewGraphData: payload,
                isAdminPageViewGraphLoader: false,
            };
        case ADMIN_PAGEVIEW_GRAPH_ACTIONS.ADMIN_PAGEVIEW_GRAPH_ERROR:
            return {
                ...state,
                pageViewGraphData: payload,
                isAdminPageViewGraphLoader: false,
            };

        // ADMIN_UNIQUEVIEW_GRAPH_ACTIONS
        case ADMIN_UNIQUEVIEW_GRAPH_ACTIONS.ADMIN_UNIQUEVIEW_GRAPH_REQUEST:
            return { ...state, isAdminUniqueViewSGraphLoader: true };
        case ADMIN_UNIQUEVIEW_GRAPH_ACTIONS.ADMIN_UNIQUEVIEW_GRAPH_RESPONSE:
            return {
                ...state,
                uniqueViewsGrapghData: payload,
                isAdminUniqueViewSGraphLoader: false,
            };
        case ADMIN_UNIQUEVIEW_GRAPH_ACTIONS.ADMIN_UNIQUEVIEW_GRAPH_ERROR:
            return {
                ...state,
                uniqueViewsGrapghData: payload,
                isAdminUniqueViewSGraphLoader: false,
            };

        // ADMIN_NAVIGATIONPATH_GRAPH_ACTIONS
        case ADMIN_NAVIGATIONPATH_GRAPH_ACTIONS.ADMIN_NAVIGATIONPATH_GRAPH_REQUEST:
            return { ...state, isAdminNavigationPathGraphLoader: true };
        case ADMIN_NAVIGATIONPATH_GRAPH_ACTIONS.ADMIN_NAVIGATIONPATH_GRAPH_RESPONSE:
            return {
                ...state,
                navigationPathGraphData: payload,
                isAdminNavigationPathGraphLoader: false,
            };
        case ADMIN_NAVIGATIONPATH_GRAPH_ACTIONS.ADMIN_NAVIGATIONPATH_GRAPH_ERROR:
            return {
                ...state,
                navigationPathGraphData: payload,
                isAdminNavigationPathGraphLoader: false,
            };

        // ADMIN_AVERAGE_SESSION_GRAPH_ACTIONS
        case ADMIN_AVERAGE_SESSION_GRAPH_ACTIONS.ADMIN_AVERAGE_SESSION_GRAPH_REQUEST:
            return { ...state, isAdminAverageSessionGraphLoader: true };
        case ADMIN_AVERAGE_SESSION_GRAPH_ACTIONS.ADMIN_AVERAGE_SESSION_GRAPH_RESPONSE:
            return {
                ...state,
                averageSessionGraphData: payload,
                isAdminAverageSessionGraphLoader: false,
            };
        case ADMIN_AVERAGE_SESSION_GRAPH_ACTIONS.ADMIN_AVERAGE_SESSION_GRAPH_ERROR:
            return {
                ...state,
                averageSessionGraphData: payload,
                isAdminAverageSessionGraphLoader: false,
            };

        // ADMIN_BOUNCE_RATE_GRAPH_ACTIONS
        case ADMIN_BOUNCE_RATE_GRAPH_ACTIONS.ADMIN_BOUNCE_RATE_GRAPH_REQUEST:
            return { ...state, isAdminBounceRateGraphLoader: true };
        case ADMIN_BOUNCE_RATE_GRAPH_ACTIONS.ADMIN_BOUNCE_RATE_GRAPH_RESPONSE:
            return {
                ...state,
                bounceRateGraphData: payload,
                isAdminBounceRateGraphLoader: false,
            };
        case ADMIN_BOUNCE_RATE_GRAPH_ACTIONS.ADMIN_BOUNCE_RATE_GRAPH_ERROR:
            return {
                ...state,
                bounceRateGraphData: payload,
                isAdminBounceRateGraphLoader: false,
            };

        // ADMIN_CTA_GRAPH_ACTIONS
        case ADMIN_CTA_GRAPH_ACTIONS.ADMIN_CTA_GRAPH_REQUEST:
            return { ...state, isAdminCTAGraphLoader: true };
        case ADMIN_CTA_GRAPH_ACTIONS.ADMIN_CTA_GRAPH_RESPONSE:
            return {
                ...state,
                CTAGraphData: payload,
                isAdminCTAGraphLoader: false,
            };
        case ADMIN_CTA_GRAPH_ACTIONS.ADMIN_CTA_GRAPH_ERROR:
            return {
                ...state,
                CTAGraphData: payload,
                isAdminCTAGraphLoader: false,
            };

        // ADMIN_ANALYTICS_TABLEDATA_ACTIONS
        case ADMIN_ANALYTICS_TABLEDATA_ACTIONS.ADMIN_ANALYTICS_TABLEDATA_REQUEST:
            return { ...state, isAdminAnalyticsTableLoader: true };
        case ADMIN_ANALYTICS_TABLEDATA_ACTIONS.ADMIN_ANALYTICS_TABLEDATA_RESPONSE:
            return {
                ...state,
                analyticsTableData: payload,
                isAdminAnalyticsTableLoader: false,
            };
        case ADMIN_ANALYTICS_TABLEDATA_ACTIONS.ADMIN_ANALYTICS_TABLEDATA_ERROR:
            return {
                ...state,
                analyticsTableData: payload,
                isAdminAnalyticsTableLoader: false,
            };

        // ADMIN_ANALYTICS_TABLEDATA_CUSTOM_ACTIONS
        case ADMIN_ANALYTICS_TABLEDATA_CUSTOM_ACTIONS.ADMIN_ANALYTICS_TABLEDATA_CUSTOM_REQUEST:
            return { ...state, isAdminAnalyticsCustomTableLoader: true };
        case ADMIN_ANALYTICS_TABLEDATA_CUSTOM_ACTIONS.ADMIN_ANALYTICS_TABLEDATA_CUSTOM_RESPONSE:
            return {
                ...state,
                analyticsCustomTableData: payload,
                isAdminAnalyticsCustomTableLoader: false,
            };
        case ADMIN_ANALYTICS_TABLEDATA_CUSTOM_ACTIONS.ADMIN_ANALYTICS_TABLEDATA_CUSTOM_ERROR:
            return {
                ...state,
                analyticsCustomTableData: payload,
                isAdminAnalyticsCustomTableLoader: false,
            };

        // ADMIN_ANALYTICS_EXITDATA_ACTIONS
        case ADMIN_ANALYTICS_EXITDATA_ACTIONS.ADMIN_ANALYTICS_EXITDATA_REQUEST:
            return { ...state, isAdminAnalyticsExitTableLoader: true };
        case ADMIN_ANALYTICS_EXITDATA_ACTIONS.ADMIN_ANALYTICS_EXITDATA_RESPONSE:
            return {
                ...state,
                analyticsExitTableData: payload,
                isAdminAnalyticsExitTableLoader: false,
            };
        case ADMIN_ANALYTICS_EXITDATA_ACTIONS.ADMIN_ANALYTICS_EXITDATA_ERROR:
            return {
                ...state,
                analyticsExitTableData: payload,
                isAdminAnalyticsExitTableLoader: false,
            };

        // ADMIN_ANALYTICS_DATA_TABLE_DATA_ACTIONS
        case ADMIN_ANALYTICS_DATA_TABLE_DATA_ACTIONS.ADMIN_ANALYTICS_DATA_TABLE_DATA_REQUEST:
            return { ...state, isAdminAnalyticsDataTableLoader: true };
        case ADMIN_ANALYTICS_DATA_TABLE_DATA_ACTIONS.ADMIN_ANALYTICS_DATA_TABLE_DATA_RESPONSE:
            return {
                ...state,
                analyticsDataTableData: payload,
                isAdminAnalyticsDataTableLoader: false,
            };
        case ADMIN_ANALYTICS_DATA_TABLE_DATA_ACTIONS.ADMIN_ANALYTICS_DATA_TABLE_DATA_ERROR:
            return {
                ...state,
                analyticsExitTableData: payload,
                isAdminAnalyticsExitTableLoader: false,
            };

        // ADMIN_ANALYTICS_CTA_GRAPH_ACTIONS
        case ADMIN_ANALYTICS_CTA_GRAPH_ACTIONS.ADMIN_ANALYTICS_CTA_GRAPH_REQUEST:
            return { ...state, isAdminAnalyticsCTAGraphLoader: true };
        case ADMIN_ANALYTICS_CTA_GRAPH_ACTIONS.ADMIN_ANALYTICS_CTA_GRAPH_RESPONSE:
            return {
                ...state,
                analyticsCTAGraphData: payload,
                isAdminAnalyticsCTAGraphLoader: false,
            };
        case ADMIN_ANALYTICS_CTA_GRAPH_ACTIONS.ADMIN_ANALYTICS_CTA_GRAPH_ERROR:
            return {
                ...state,
                analyticsCTAGraphData: payload,
                isAdminAnalyticsCTAGraphLoader: false,
            };

        // ADMIN_DEVICE_BROWSER_CHART_ACTIONS
        case ADMIN_DEVICE_BROWSER_CHART_ACTIONS.ADMIN_DEVICE_BROWSER_CHART_REQUEST:
            return { ...state, isAdminDeviceBrowserChartLoader: true };
        case ADMIN_DEVICE_BROWSER_CHART_ACTIONS.ADMIN_DEVICE_BROWSER_CHART_RESPONSE:
            return {
                ...state,
                deviceBrowserChartData: payload,
                isAdminDeviceBrowserChartLoader: false,
            };
        case ADMIN_DEVICE_BROWSER_CHART_ACTIONS.ADMIN_DEVICE_BROWSER_CHART_ERROR:
            return {
                ...state,
                deviceBrowserChartData: payload,
                isAdminDeviceBrowserChartLoader: false,
            };

        // ADMIN_COUNTRY_USERS_CHART_ACTIONS
        case ADMIN_COUNTRY_USERS_CHART_ACTIONS.ADMIN_COUNTRY_USERS_CHART_REQUEST:
            return { ...state, isAdminCountryUsersChartLoader: true };
        case ADMIN_COUNTRY_USERS_CHART_ACTIONS.ADMIN_COUNTRY_USERS_CHART_RESPONSE:
            return {
                ...state,
                countryUsersChartData: payload,
                isAdminCountryUsersChartLoader: false,
            };
        case ADMIN_COUNTRY_USERS_CHART_ACTIONS.ADMIN_COUNTRY_USERS_CHART_ERROR:
            return {
                ...state,
                countryUsersChartData: payload,
                isAdminCountryUsersChartLoader: false,
            };

        // ADMIN_ADS_LOG_DATA_TABLE_ACTIONS
        case ADMIN_ADSLOG_DATA_TABLE_ACTIONS.ADMIN_ADSLOG_DATA_TABLE_REQUEST:
            return { ...state, isAdminAdsLogDataTableLoader: true };
        case ADMIN_ADSLOG_DATA_TABLE_ACTIONS.ADMIN_ADSLOG_DATA_TABLE_RESPONSE:
            return {
                ...state,
                adsLogDataTableData: payload,
                isAdminAdsLogDataTableLoader: false,
            };
        case ADMIN_ADSLOG_DATA_TABLE_ACTIONS.ADMIN_ADSLOG_DATA_TABLE_ERROR:
            return {
                ...state,
                adsLogDataTableData: payload,
                isAdminAdsLogDataTableLoader: false,
            };

        default:
            return state;
    }
};
